// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-containertwo[data-v-2c058956]{background:#fff;padding:1.666667rem .833333rem}.pagination-containertwo.hidden[data-v-2c058956]{display:none}", ""]);
// Exports
module.exports = exports;
